import { render, staticRenderFns } from "./smart-cover.vue?vue&type=template&id=626e3084&scoped=true"
import script from "./smart-cover.vue?vue&type=script&lang=js"
export * from "./smart-cover.vue?vue&type=script&lang=js"
import style0 from "./smart-cover.vue?vue&type=style&index=0&id=626e3084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e3084",
  null
  
)

export default component.exports